import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutGrid, BarChart3, Truck, ClipboardCheck, Car, AlertTriangle, TrendingUp, Gauge, UserCheck, CreditCard,
  Users, ShieldCheck, UserCog, Sliders, FileSpreadsheet, LogOut, Menu, X, Database, IdCard, Wrench, Siren, FolderLock, Boxes, CalendarClock, FileText, QrCode, Droplets, Fuel, Palmtree,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function navFor(user) {
  const r = user.role;
  const s = [{ items: [{ to: "/", label: "Accueil", icon: LayoutGrid, end: true }] }];
  if (r === "admin") s[0].items.push({ to: "/dashboard", label: "Tableau de bord", icon: BarChart3 });
  if (r === "admin")
    s.push({ title: "Véhicules de livraison", items: [
      { to: "/livraison/dashboard", label: "Tableau de bord", icon: Truck },
      { to: "/livraison/controle", label: "Contrôle véhicule", icon: ClipboardCheck },
      { to: "/livraison/vehicules", label: "Véhicules", icon: Car },
      { to: "/livraison/anomalies", label: "Anomalies", icon: AlertTriangle },
      { to: "/livraison/accidents", label: "Accidents / Sinistres", icon: Siren },
      { to: "/livraison/chauffeurs", label: "Chauffeurs", icon: Users },
      { to: "/livraison/entretien", label: "Entretien", icon: Wrench },
      { to: "/livraison/carburant", label: "Cartes carburant Fleet Pro", icon: CreditCard },
      { to: "/livraison/adblue", label: "Carburant / AdBlue", icon: Droplets },
    ] });
  if (r === "chauffeur")
    s.push({ title: "Véhicules de livraison", items: [
      { to: "/livraison/dashboard", label: "Tableau de bord", icon: Truck },
      { to: "/livraison/controle", label: "Contrôle véhicule", icon: ClipboardCheck },
      { to: "/livraison/vehicules", label: "Véhicules", icon: Car },
      { to: "/livraison/anomalies", label: "Anomalies", icon: AlertTriangle }, { to: "/livraison/chauffeurs", label: "Chauffeurs", icon: Users },
      { to: "/livraison/accidents", label: "Accidents / Sinistres", icon: Siren },
      { to: "/livraison/entretien", label: "Entretien", icon: Wrench },
      { to: "/livraison/carburant", label: "Cartes carburant Fleet Pro", icon: CreditCard },
      ...(user.real_role === "chef_depot" ? [] : [{ to: "/livraison/plein", label: "Enregistrer un plein Fleet Pro", icon: Fuel }]),
      { to: "/livraison/adblue", label: "Carburant / AdBlue", icon: Droplets },
    ] });
  if (r === "chauffeur" && user.m2_self)
    s.push({ title: "Mon véhicule (Module 2)", items: [
      { to: "/commerciaux/espace", label: "Mon espace", icon: IdCard },
      { to: "/commerciaux/vehicules", label: "Mon véhicule", icon: Car },
      { to: "/commerciaux/espace?tab=vehicule", label: "Congés avec le véhicule", icon: Palmtree },
      { to: "/commerciaux/accidents", label: "Accidents / Sinistres", icon: Siren },
      { to: "/commerciaux/plein", label: "Enregistrer un plein", icon: Fuel },
      { to: "/commerciaux/releve", label: "Relevé kilométrique", icon: Gauge },
      { to: `/commerciaux/equipe/${user.id}`, label: "Ma fiche véhicule", icon: IdCard },
    ] });
  if (r === "admin")
    s.push({ title: "Véhicules commerciaux", items: [
      { to: "/commerciaux/dashboard", label: "Tableau de bord", icon: TrendingUp },
      { to: "/commerciaux/vehicules", label: "Véhicules", icon: Car },
      { to: "/commerciaux/accidents", label: "Accidents / Sinistres", icon: Siren },
      { to: "/commerciaux/conges", label: "Congés avec véhicule", icon: Palmtree },
      { to: "/commerciaux/releve", label: "Relevé kilométrique", icon: Gauge },
      { to: "/commerciaux/km-perso", label: "Kilométrage personnel", icon: UserCheck },
      { to: "/commerciaux/carburant", label: "Carburant", icon: CreditCard },
      { to: "/commerciaux/mobilite", label: "Mobilité / énergie", icon: Fuel },
      { to: "/commerciaux/equipe", label: "Commerciaux & techniciens", icon: Users },
      { to: "/commerciaux/entretien", label: "Entretien", icon: Wrench },
    ] });
  if (r === "commercial") {
    const items = [{ to: "/commerciaux/espace", label: "Mon espace", icon: IdCard }, { to: "/commerciaux/vehicules", label: "Mon véhicule", icon: Car }, { to: "/commerciaux/espace?tab=vehicule", label: "Congés avec le véhicule", icon: Palmtree }, { to: "/commerciaux/accidents", label: "Accidents / Sinistres", icon: Siren }, { to: "/commerciaux/plein", label: "Enregistrer un plein", icon: Fuel }, { to: "/commerciaux/releve", label: "Relevé kilométrique", icon: Gauge }, { to: "/commerciaux/entretien", label: "Entretien", icon: Wrench }];
    if (user.can_view_history) {
      items.push({ to: "/commerciaux/km-perso", label: "Kilométrage personnel", icon: UserCheck });
      items.push({ to: `/commerciaux/equipe/${user.id}`, label: "Ma fiche", icon: IdCard });
    }
    s.push({ title: "Véhicules commerciaux", items });
  }
  if (r === "admin" || r === "chauffeur")
    s.push({ title: "Matériel entrepôt", items: [
      { to: "/materiel/dashboard", label: "Tableau de bord", icon: Boxes },
      { to: "/materiel/controle", label: "Contrôle mensuel", icon: ClipboardCheck },
      { to: "/materiel/liste", label: "Matériels", icon: Boxes },
      { to: "/materiel/anomalies", label: "Anomalies", icon: AlertTriangle },
      { to: "/materiel/dekra", label: "Entretien / DEKRA", icon: CalendarClock },
      ...(r === "admin" || r === "chauffeur" ? [{ to: "/materiel/documents", label: "Documents", icon: FileText }, { to: "/materiel/qr", label: "QR codes", icon: QrCode }] : []),
    ] });
  if (r === "administratif") s.push({ title: "Administratif", items: [{ to: "/documents", label: "Documents & permis", icon: FolderLock }] });
  if (r === "admin") {
    s.push({ title: "Flotte", items: [{ to: "/flotte", label: "Tous les véhicules", icon: ShieldCheck }, { to: "/documents", label: "Documents & permis", icon: FolderLock }] });
    s.push({ title: "Paramètres", items: [
      { to: "/parametres/utilisateurs", label: "Utilisateurs", icon: UserCog },
      { to: "/parametres/vehicules", label: "Véhicules", icon: Car },
      { to: "/parametres/seuils", label: "Seuils d'alerte", icon: Sliders },
      { to: "/parametres/imports", label: "Imports", icon: FileSpreadsheet },
      { to: "/parametres/sauvegarde", label: "Sauvegarde", icon: Database },
    ] });
  }
  return s.map((sec) => user.real_role === "direction" ? { ...sec, items: sec.items.filter((i) => !["/livraison/controle", "/materiel/controle", "/commerciaux/releve", "/parametres/imports", "/parametres/vehicules", "/parametres/seuils", "/parametres/sauvegarde"].includes(i.to)) } : sec);
}

const slug = (to) => to.replace(/\//g, "-").replace(/^-/, "") || "home";

function Sidebar({ user, onNav, onLogout }) {
  return (
    <div className="h-full flex flex-col bg-[#0E2D43] text-white grain">
      <div className="px-5 pt-5 pb-4 flex flex-col items-center border-b border-white/10">
        <img src="/logo-presthyg.png" alt="Prest'hyg" className="w-36 h-auto mix-blend-lighten" data-testid="sidebar-logo" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#F49619] font-bold mt-1">Gestion de flotte</div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 pb-4" data-testid="sidebar-nav">
        {navFor(user).map((sec, i) => (
          <div key={i} className="mt-4">
            {sec.title && <div className="px-3 mb-1.5 text-[10px] uppercase tracking-[0.2em] font-bold text-white/40">{sec.title}</div>}
            {sec.items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                onClick={onNav}
                data-testid={`nav-${slug(it.to)}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive ? "bg-[#F49619] text-[#0E2D43] font-semibold" : "text-white/75 hover:bg-white/10 hover:text-white"
                  }`
                }
              >
                <it.icon className="w-4 h-4 shrink-0" />
                {it.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="border-t border-white/10 p-4 flex items-center gap-3">
        <NavLink to="/profil" onClick={onNav} className="min-w-0 flex-1 flex items-center gap-3 rounded-md hover:bg-white/10 -m-1 p-1 transition-colors" data-testid="nav-profil">
        <div className="w-9 h-9 rounded-full bg-white/10 grid place-items-center text-sm font-bold shrink-0">{user.name?.[0]}</div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold truncate" data-testid="current-user-name">{user.name}</div>
          <div className="text-[11px] text-white/50">{user.real_role === "direction" ? "Direction · lecture seule" : "Mon profil"}</div>
        </div>
        </NavLink>
        <button onClick={onLogout} className="p-2 rounded-md hover:bg-white/10" data-testid="logout-button" title="Déconnexion">
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default function AppLayout() {
  const { user, demo, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const doLogout = () => {
    logout();
    nav("/login");
  };
  return (
    <div className="min-h-screen lg:pl-64">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 z-30">
        <Sidebar user={user} onLogout={doLogout} />
      </aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-72 h-full shadow-2xl"><Sidebar user={user} onNav={() => setOpen(false)} onLogout={doLogout} /></div>
          <button className="flex-1 bg-black/40 backdrop-blur-sm" onClick={() => setOpen(false)} data-testid="mobile-nav-close" aria-label="Fermer">
            <X className="w-6 h-6 text-white ml-4" />
          </button>
        </div>
      )}
      <div className="sticky top-0 z-20">
      {demo && (
        <div className="bg-[#F49619] text-[#0E2D43] text-xs sm:text-sm font-semibold px-4 py-2 flex items-center gap-2" data-testid="demo-banner">
          <Database className="w-4 h-4 shrink-0" />
          <span>Données de démonstration — les véhicules, collaborateurs et montants affichés sont fictifs.</span>
        </div>
      )}
      <header className="lg:hidden bg-[#0E2D43] text-white flex items-center justify-between px-4 h-14">
        <button onClick={() => setOpen(true)} data-testid="mobile-nav-open" className="p-2 -ml-2" aria-label="Menu">
          <Menu className="w-5 h-5" />
        </button>
        <span className="font-display font-bold">Prest'hyg Flotte</span>
        <span className="w-9" />
      </header>
      </div>
      <main className="min-w-0 px-4 sm:px-6 lg:px-10 py-6 lg:py-10 max-w-[1700px]">
        <Outlet />
      </main>
    </div>
  );
}
